export const heroTypes = {
    medic:"bonus heal",
    orator:"bonus luck",
    ingenier:"bonus build",
    figther:"bonus attack",
    tactician: "bonus defence"
  }